import { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  InputAdornment,
  CircularProgress,
  Typography
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


/**
 * Modal for user to enter and confirm new password
 * @param {object} props
 * @param {boolean} props.open - Check if the modal is open
 * @param {function} props.onClose - Function to call when the modal closes
 * @param {function(string): void} props.onConfirm - Function to call with code when confirmed
 * @param {boolean} [props.loading=false] - If true, display a spinner on the confirm button
 */
const ChangePasswordModal = ({ open, onClose, onConfirm, loading = false }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (password && confirmPassword && password !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
    } else if (password && password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
    } else {
      setError('');
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (!open) {
      setPassword('');
      setConfirmPassword('');
      setError('');
      setShowPassword(false);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!error) {
      onConfirm(password);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Cambiar Contraseña</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Ingresa tu nueva contraseña. Debe tener al menos 8 caracteres.
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          id="new-password"
          label="Nueva Contraseña"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={!!error}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="dense"
          id="confirm-password"
          label="Confirmar Contraseña"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          variant="outlined"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!password || !!error || loading}
          sx={{
            borderRadius: "0px !important",
            fontWeight: "bolder !important",
            fontSize: "1rem !important"
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirmar Cambio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
